import React, { Component } from 'react';
import FullHeightIFrame from '../../shared/components/FullHeightIFrame';

export default class Tos extends Component {
    render() {
        return (
            <div className="ac-page">
                <FullHeightIFrame src="/resource/t/_common/tos.html" />
            </div>
        );
    }
}